import { HttpClient } from 'api/http-client';
import { CustomerPin } from './types';

class SpotlightHttpClient extends HttpClient {
  public async getPinsByScopeAndResource(
    scopeId: number,
    scopeType: string,
    resourceType: string,
  ): Promise<CustomerPin[]> {
    return this.get(
      `/customer-pins/scope/${scopeType}/${scopeId}/resource/${resourceType}`,
    );
  }

  public async getPinByResourceAndScope(
    resourceId: number,
    resourceType: string,
    scopeId: number,
    scopeType: string,
  ): Promise<CustomerPin> {
    return this.get(
      `/customer-pins/scope/${scopeType}/${scopeId}/resource/${resourceType}/${resourceId}`,
    );
  }

  // upsertPinnedOnResourceAndParentAndAccount
  public async addPinOnResourceWithScope(
    resourceId: number,
    resourceType: string,
    scopeId: number,
    scopeType: string,
    mapping: CustomerPin,
  ): Promise<CustomerPin> {
    return this.post(
      `/customer-pins/scope/${scopeType}/${scopeId}/resource/${resourceType}/${resourceId}/`,
      mapping,
    );
  }

  // deleteMapping parent and resource
  public async deletePinOnResourceWithScope(
    resourceId: number,
    resourceType: string,
    scopeId: number,
    scopeType: string,
  ): Promise<CustomerPin> {
    return this.delete(
      `/customer-pins/scope/${scopeType}/${scopeId}/resource/${resourceType}/${resourceId}`,
    );
  }
}

export const SpotlightApi = new SpotlightHttpClient();
